import { Component, Inject, OnChanges, SimpleChanges } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { NavigationStart, Router } from '@angular/router';
import { EncryptDecryptService } from 'src/app/core/services/encrypt-decrypt.service';
import { CommonFunctions } from '../../common-functions';
declare var dataLayer;
@Component({
  selector: 'app-starry-tip',
  templateUrl: './starry-tip.component.html',
  styleUrls: ['./starry-tip.component.scss']
})
export class StarryTipComponent implements OnChanges {
  public currentURL;
  public newURL;
  userType: string;
  userId: any;
  tierType: any;
  isLoggedIn: boolean;
  tierDetails: any;
  numberOfStars: any;
  constructor(
    private encryptDecryptService: EncryptDecryptService,
    private _snackRef: MatSnackBarRef<StarryTipComponent>,
    private router: Router,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private commonFunction: CommonFunctions
  ) {
    this.getURL();
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
    this.isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if (this.isLoggedIn) {
      this.tierDetails = JSON.parse(localStorage.getItem('user_profile'));
      this.tierDetails.currentStarBalance = this.tierDetails.currentStarBalance != null ? this.encryptDecryptService.decryptData(this.tierDetails.currentStarBalance) : 0;
      this.tierDetails.rewardCount = this.tierDetails.rewardCount != null ? this.encryptDecryptService.decryptData(this.tierDetails.rewardCount) : 0;
      this.tierDetails.tierUpperLimit = this.tierDetails.tierUpperLimit != null ? this.encryptDecryptService.decryptData(this.tierDetails.tierUpperLimit) : 0;
    }
    if (this.tierDetails && this.tierDetails.currentStarBalance != undefined && this.tierDetails.tierUpperLimit) {
      this.numberOfStars = this.tierDetails.currentStarBalance
    } else {
      this.numberOfStars = 'NA';
    }
  }
  getURL() {
    let starryScreen = sessionStorage.getItem('starryScreen');
    this.currentURL = this.router.url;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.newURL = event.url;
        if (this.newURL) {
          if (this.newURL != this.currentURL) {
            this._snackRef.dismiss();
          }
        }
      }
    })
  }
  ngOnChanges(changes: SimpleChanges): void {
  }
  close(data) {
    sessionStorage.setItem('hideStarryScreen', data['starryScreenName']);
    this._snackRef.dismiss();
  }
  starryTipCloseGA() {
    dataLayer.push({
      'event': 'starry_tips_close_click',
      'userID': this.userId,
      'user_type': this.userType,
      'number_of_stars': this.numberOfStars,
      'rewards': (this.tierDetails && this.tierDetails.rewardCount) ? this.tierDetails.rewardCount : 'NA',
      'tier': this.tierType
    })
  }
}
